import React, { memo, useMemo, useCallback } from 'react';
import classnames from 'classnames';
import { createUseStyles, Text, Icon, Checkbox, Menus, Tooltip, Loader } from '@Sage/hoi-poi-ui';

import styles from './styles';

const useStyles = createUseStyles(styles, 'WidgetHeader');

const Header = memo(
    ({ title, isSelected, onSelect, actions, menuItems, isLoaded, isLoadingDuplicate }) => {
        const classes = useStyles();

        const stopPropagation = useCallback((e) => {
            e?.stopPropagation?.();
        }, []);

        const overridesIcon = useMemo(
            () => ({
                root: {
                    onMouseDown: stopPropagation,
                },
            }),
            [stopPropagation],
        );

        const overridesMenu = useMemo(
            () => ({
                root: {
                    onMouseDown: stopPropagation,
                },
            }),
            [stopPropagation],
        );

        const renderActions = useMemo(() => {
            if (!actions?.length) return null;
            let iconActions = [];

            actions.forEach((current, index) => {
                const { title, iconName, onClick } = current;

                if (title) {
                    iconActions.push(
                        <Icon
                            key={index}
                            name={iconName}
                            onClick={onClick}
                            overrides={overridesIcon}
                            tooltip={title}
                        />,
                    );
                } else {
                    iconActions.push(
                        <Icon
                            key={index}
                            name={iconName}
                            onClick={onClick}
                            overrides={overridesIcon}
                            tooltip={title}
                        />,
                    );
                }
            });

            return iconActions;
        }, [actions, overridesIcon]);

        return (
            <div
                className={classnames(classes.root, { [classes.isSelected]: isSelected || false })}
            >
                {isLoaded && onSelect && (
                    <div className={classes.selector}>
                        <Checkbox
                            checked={isSelected}
                            onChange={onSelect}
                            color="actionMajor"
                            overrides={overridesIcon}
                        />
                    </div>
                )}
                {title && (
                    <Tooltip content={title}>
                        <Text className={classes.title} size="big" type="h6" isTruncated={true}>
                            {title}
                        </Text>
                    </Tooltip>
                )}
                {isLoaded && (actions?.length > 0 || menuItems?.length > 0) && (
                    <div
                        className={classnames(classes.actions, {
                            [classes.noActions]: isSelected || false,
                        })}
                    >
                        {renderActions}
                        {isLoadingDuplicate && <Loader size="tiny" />}
                        {!isLoadingDuplicate && menuItems?.length > 0 && (
                            <Menus
                                icon={<Icon name="moreHoriz" />}
                                items={menuItems}
                                overrides={overridesMenu}
                                triggerAction="hover"
                                classNameMenu={classes.menuPopover}
                                placement="bottom-start"
                            />
                        )}
                    </div>
                )}
            </div>
        );
    },
);

export default Header;
